var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 12,
    viewBox: "0 0 18 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 11C0 11.5523 0.447715 12 1 12H12C12.5523 12 13 11.5523 13 11C13 10.4477 12.5523 10 12 10H1C0.447715 10 0 10.4477 0 11ZM0 6C0 6.55228 0.447715 7 1 7H9C9.55228 7 10 6.55228 10 6C10 5.44772 9.55229 5 9 5H1C0.447715 5 0 5.44772 0 6ZM1 0C0.447715 0 0 0.447715 0 1C0 1.55228 0.447715 2 1 2H12C12.5523 2 13 1.55228 13 1C13 0.447715 12.5523 0 12 0H1ZM17.2955 10.2945C17.6847 9.90526 17.6852 9.2743 17.2965 8.88451L14.42 6L17.2965 3.11549C17.6852 2.7257 17.6847 2.09474 17.2955 1.70549C16.9059 1.31586 16.2741 1.31586 15.8845 1.70549L11.59 6L15.8845 10.2945C16.2741 10.6841 16.9059 10.6841 17.2955 10.2945Z",
    fill: "#3E3E3E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.938fc2bb.svg";
export { ForwardRef as ReactComponent };